const ADMIN_PAYMENT_REQUEST_OPTIONS = Object.freeze({
  baseURL: '/',
});

export const getAdminPaymentRequestOptions = () => ADMIN_PAYMENT_REQUEST_OPTIONS;
